import { memo } from 'react'

import { useTranslation } from 'react-i18next'

import { Header } from '@shared/components/Header'
import { Content } from '@shared/layouts'

const StructureRaw = () => {
  const { t } = useTranslation(['pages'])

  return <Content HeaderSlot={<Header title={t('pages:My.organizations')} disabled />} />
}

export const Structure = memo(StructureRaw)
